/**
 * main.ts
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */
// Composables
import { createApp } from 'vue'

// Plugins
import { globallyRegisterDesignSystemComponents } from '@/design-system/register-components'
import { registerPlugins } from '@/plugins'

import App from './App.vue'

const app = createApp(App)

async function init () {
  await registerPlugins(app)
  globallyRegisterDesignSystemComponents(app)

  // Both of those env vars come from vue.config.js because they're computed
  console.info(`closd-front version ${__APP_VERSION__} rev ${__APP_REVISION__}`)

  app.mount('#app')
}

init()
